import { Anchor, FormHelp, Heading, Popover, Text } from '@zillow/constellation-10';

import numberUtils from '../../../utils/numberUtils';

type Props = {
  rentZestimate?: number;
  showAnalyze?: boolean;
};

const ZestimateHelper = ({ rentZestimate = 0, showAnalyze = false }: Props) => (
  <FormHelp data-testid="ZestimateHelper">
    {`The current Rent Zestimate: ${numberUtils.asCurrencyWithDefault(rentZestimate, '-', '$0,0')}/mo `}
    <Popover
      header={<Heading level={5}>Rent Zestimate®</Heading>}
      body={
        <>
          <Text>
            A Rent Zestimate® is Zillow&apos;s estimated monthly rental price, computed using a proprietary formula. It
            is a starting point in determining the monthly rental price for a specific property.
          </Text>
          <Text css={{ marginTop: '200' }} asChild>
            <p>
              <Anchor
                target="_blank"
                href="https://www.zillow.com/info/what-is-a-rent-zestimate/"
                rel="noopener noreferrer"
              >
                Learn more about Zestimates
              </Anchor>
              .
            </p>
          </Text>
        </>
      }
      trigger={<Popover.Trigger css={{ paddingRight: '200' }} />}
    />
    {showAnalyze && (
      <Anchor target="_blank" href="/rental-manager/price-my-rental/" rel="noopener noreferrer">
        Analyze
      </Anchor>
    )}
  </FormHelp>
);

export { ZestimateHelper };
export default ZestimateHelper;
